<template>
  <div class="cotton-home" ref="monitorEl">
    <RightButton ref="rightButtonRef" :model="model" @switchMenu="handleSwitchMenu" />
    <div class="cotton-home_content">
      <router-view />
    </div>

    <DeviceParamsDialog
      v-if="params.visible"
      :sn="params.sn"
      :deviceType="params.deviceType"
      :visible.sync="params.visible"
    />
  </div>
</template>

<script>
import deviceType from '@/utils/const/deviceType';
import RightButton from './components/RightButton/index.vue';
import DeviceParamsDialog from '@/components/deviceParamDialog/index.vue';
import { isEmpty } from '@/utils/is';
import { officeTypeDict } from '@/utils/const/office';
import ctt from '@/utils/const';

export default {
  components: {
    RightButton,
    DeviceParamsDialog
  },
  sockets: {
    '/socket/detect/detail'(data) {
      if (data.deviceType != deviceType.CD_603) return;

      if (
        isEmpty(data.mods) ||
        isEmpty(data.mods.cd603Mod) ||
        isEmpty(data.mods.cd603Mod.cd603Smolder)
      ) {
        return;
      }

      const { mods, longitude, latitude, officeId } = data;

      const { cd603Mod } = mods;

      const { cd603Smolder } = cd603Mod;

      const { deviceBatteryInfo } = cd603Smolder;

      const { batterLevel, chargeState } = deviceBatteryInfo;

      const { testResult, testTime } = cd603Smolder;

      const item = {
        sn: cd603Smolder.sn,
        stripeCode: cd603Smolder.testBarCode,
        gps: [longitude, latitude],
        batteryPercent: batterLevel,
        isCharging: chargeState == 1,
        result: testResult,
        datetime: testTime,
        officeId
      };

      if (!this.cd603DetectionDataGroup[item.officeId]) {
        this.$set(this.cd603DetectionDataGroup, item.officeId, []);
      }

      this.cd603DetectionDataGroup[item.officeId].unshift(item);

      if (this.cd603DetectionDataGroup[item.officeId].length > 20) {
        this.cd603DetectionDataGroup[item.officeId].splice(20, Infinity);
      }
    }
  },
  data() {
    return {
      cd603DetectionDataGroup: {},
      model: {
        officeId: sessionStorage.getItem('currentCottonOfficeId'),
        officeType: sessionStorage.getItem('currentCottonOfficeType')
      },
      params: {
        sn: '',
        deviceType: '',
        visible: false
      }
    };
  },
  provide() {
    return {
      openParamsDialog: params => this.openParamsDialog(params),
      currentOfficeInfo: this.model,
      getCd603DetectionData: () => this.currentOfficeCD603DetectionData,
      getDeviceTypeList: () => this.deviceTypeList
    };
  },
  computed: {
    currentOfficeCD603DetectionData() {
      const list = this.cd603DetectionDataGroup[this.model.officeId] || [];

      return list;
    },
    deviceTypeList() {
      const { officeType } = this.model;

      if (isEmpty(officeType)) return [];

      const list = [];

      if (officeType == officeTypeDict.enum['堆场'].key) {
        list.push(
          { label: '阴燃巡检仪', value: ctt.CD_602 },
          { label: '阴燃探测仪', value: ctt.CD_603 }
        );
      }

      if (officeType == officeTypeDict.enum['轧花厂'].key) {
        list.push(
          { label: '阴燃遥测仪', value: ctt.FR_01 },
          { label: '在线阴燃监测模块', value: ctt.ZX27 }
        );
      }

      return list;
    }
  },
  methods: {
    handleSwitchMenu(key) {
      console.log(key);
    },
    openParamsDialog(params) {
      this.params.deviceType = params.deviceType;
      this.params.sn = params.sn;
      this.params.visible = true;
    }
  },
  watch: {
    model: {
      handler(val) {
        sessionStorage.setItem('currentCottonOfficeId', val.officeId);
        sessionStorage.setItem('currentCottonOfficeType', val.officeType);
      },
      deep: true
    }
  },
  mounted() {}
};
</script>

<style lang="scss">
.cotton-home {
  position: relative;
  height: 100%;

  --gap: 15px;

  --bottom-width: 100%;
  --bottom-height: 45%;
  --top-height: calc(55% - var(--gap));
  --header-height: 10px;

  --mcard-header-title-color: var(--cotton-mcard-header-title-color);

  --mcard-header-fs: 26px;

  &_content {
    width: calc(100% - 155px);
    height: calc(100% - var(--header-height) - 15px);

    position: absolute;
    left: 15px;
    top: var(--header-height);
    z-index: 6;
  }

  .el-tree-select {
    .el-select {
      width: 276px;
    }
  }

  .nova-contextmenu {
    padding: 0;

    & > ul {
      li {
        list-style: none;
        padding: 7px 15px;
        cursor: pointer;
        transition: background 0.3s ease;
        height: 26px;
        line-height: 26px;
      }
    }
  }

  .position-dialog-wrap {
    .el-dialog {
      background: url('/static/image/cotton/dialog-bg.png') 0 0 / 100% 100% no-repeat;

      &__title {
        line-height: 24px;
        font-size: 23px;
        color: var(--cotton-dialog-title-color);
        font-weight: bold;
      }

      &__header {
        text-align: center;
        padding: 13px 20px 10px;
      }

      &__body {
        padding: 10px;
      }
    }
  }
}
</style>
